import Icon from '../components/Icon.vue'

Icon.register({"minus-square":{"width":448,"height":512,"paths":[{"d":"M400 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H400C426.5 480 448 458.5 448 432V80C448 53.5 426.5 32 400 32zM92 296C85.4 296 80 290.6 80 284V228C80 221.4 85.4 216 92 216H356C362.6 216 368 221.4 368 228V284C368 290.6 362.6 296 356 296H92z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/minus-square.js
// module id = cG06
// module chunks = 0